import React from 'react';

import pageImg from 'img/icon/questionnaire-survey.svg';

import Intro from 'components/Intro';
import Placeholder from 'components/Placeholder';
import { Link } from 'react-router-dom';

const Content = () => {
  const pageData = {
    title: '問卷調查',
    icon: pageImg,
  };
  return (
    <>
      <article className="l-questionnaire-survey u-section">
        <section className="l-questionnaire-survey__title u-section">
          <Intro data={pageData} />
          <div className="row g-0 justify-content-center">
            <div className="col-12 row align-items-center">
              <p className="row justify-content-center h5">
                LSTER長期社會核心觀測彰化站-2025芳苑鄉問卷調查
              </p>
              <p className="row justify-content-center h5">
                第一波：濱海三區調查
              </p>
              <p className="h5">【調查目的】</p>
              <p>
                本次問卷調查計畫為LTSER彰化站團隊與東海大學社會學系王維邦副教授、謝志龍副教授協同研究。為瞭解芳苑鄉居民對於環境及社會變遷狀況的認知，藉由長時間的追蹤與分析，嘗試建立基礎的海岸社會人地互動關係地方知識。
              </p>
              <p>
                在這次的計畫中，研究團隊從內政部公開的全國門牌資料，隨機抽取芳苑鄉沿海共15個村裡的1,173戶作為受訪家戶，並指派面訪員實際前往被抽樣的地址進行問卷調查。
              </p>
              <p>
                關於問卷其他詳細資訊及聯絡方式請參閱：
                <Link
                  to="https://data.depositar.io/dataset/ltser-2025fyquestionnaire"
                  className="e-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://data.depositar.io/dataset/ltser-2025fyquestionnaire
                </Link>
              </p>
            </div>
          </div>
        </section>
      </article>
    </>
  );
};

export default Content;
